import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_camera_online_line",
  "use": "icon-icon_general_camera_online_line-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-icon_general_camera_online_line\">\n<path class=\"st0\" d=\"M34,18.9V14H6v20h28v-4.9l8,2.9V16L34,18.9z M32,32H8V16h24V32z M40,29.1L34,27v-6l6-2.2V29.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol